import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core/styles';
import LoginTextField from '../../../fields/normal/LoginTextField';
import styles from './style';

const validate = values => {
  const errors = {};
  const requiredFields = ['password'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });
  if (values.password && !/^.{8,}$/i.test(values.password)) {
    errors.password = 'Password must have at least 8 characters';
  }
  return errors;
};

const renderTextField = ({
  label,
  labelTouched,
  labelUntouched,
  FormHelperText,
  input,
  meta: { touched, invalid, error, dirty, active },
  ...custom
}) => (
  <LoginTextField
    // label={active ? 'active' : 'notactive'}
    label={
      label || (labelTouched && dirty) || active || touched
        ? labelTouched
        : labelUntouched || 'generic label'
    }
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

const NewPwForm = props => {
  const {
    handleSubmit,
    handleBackToNormalForm,
    handleTryAgain,
    pristine,
    submitting,
    classes,
    invalid,
    isLoginLoading,
    submitFailed,
    error,
  } = props;
  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className={classes.fieldContain}>
          <Field
            name="password"
            component={renderTextField}
            labelUntouched={
              <Typography
                variant="h6"
                color="textSecondary"
                className={classes.placeText}
              >
                enter new password
              </Typography>
            }
            labelTouched={
              <Typography
                variant="h6"
                color="textSecondary"
                className={classes.placeText}
              >
                new password
              </Typography>
            }
            type="password"
          />
        </div>
        {submitFailed && error && (
          <div className={classes.submitFailedContain}>
            <Typography
              className={classes.submitFailed_message}
              onClick={handleTryAgain}
              variant="h6"
              color="error"
            >
              {error}
            </Typography>
            <Typography
              className={classes.submitFailed_link}
              onClick={handleTryAgain}
              variant="button"
            >
              Try again
            </Typography>
          </div>
        )}
        <div className={classes.tipIconContain}>
          <span className={classes.tipIcon}>
            <Typography>
              {/* <Typography color="textSecondary"> */}
              {invalid ? <InfoIcon /> : <CheckIcon />}
            </Typography>
          </span>
          <span className={classes.tipIconText}>
            <Typography variant="body1">
              {'Use 8 or more characters.'}
            </Typography>
          </span>
        </div>
        <div className={classes.buttonContain}>
          <div className={classes.buttonContain_back}>
            <Button
              className={classes.mainButton}
              onClick={handleBackToNormalForm}
              variant="contained"
              color="primary"
            >
              Cancel
            </Button>
          </div>
          <Button
            className={classes.mainButton}
            // className={invalid && classes.hidden}
            type="submit"
            disabled={pristine || submitting || invalid || isLoginLoading}
            variant="contained"
            color="primary"
          >
            Confirm
            {isLoginLoading && (
              <CircularProgress size={34} className={classes.buttonProgress} />
            )}
          </Button>
        </div>
      </form>
    </>
  );
};

renderTextField.propTypes = {
  label: PropTypes.any,
  labelTouched: PropTypes.any,
  labelUntouched: PropTypes.any,
  FormHelperText: PropTypes.any,
  input: PropTypes.any,
  meta: {
    touched: PropTypes.any,
    invalid: PropTypes.any,
    error: PropTypes.any,
    dirty: PropTypes.any,
    active: PropTypes.any,
  },
};

NewPwForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleBackToNormalForm: PropTypes.func,
  handleTryAgain: PropTypes.func,
  pristine: PropTypes.any,
  submitting: PropTypes.any,
  classes: PropTypes.object,
  invalid: PropTypes.any,
  isLoginLoading: PropTypes.bool,
  submitFailed: PropTypes.any,
  error: PropTypes.any,
};

export default withStyles(styles)(
  reduxForm({
    form: 'NewPwForm', // a unique identifier for this form
    validate,
  })(NewPwForm),
);
